import { SPLIDE_TRACK_CLASS_NAME, SPLIDE_TRACK_ELEMENT_SELECTOR, SPLIDE_LIST_CLASS_NAME, SPLIDE_LIST_ELEMENT_SELECTOR, SPLIDE_SLIDE_CLASS_NAME, SPLIDE_SLIDE_CLASS_SELECTOR, SPLIDE_ARROWS_CLASS_NAME, SPLIDE_ARROWS_ELEMENT_SELECTOR, SPLIDE_ARROW_CLASS_NAME, SPLIDE_ARROW_ELEMENT_SELECTOR, SPLIDE_ARROW_PREV_CLASS_NAME, SPLIDE_ARROW_NEXT_CLASS_NAME, CUSTOM_ARROW_PREV, CUSTOM_ARROW_NEXT, SPLIDE_ACTIVE_CLASS_NAME, SPLIDE_ACTIVE_CLASS_NAME_CSS_MODULE } from "./splide-constants.js";
const addClassName = (root, selector, splideClass)=>{
    const element = root.querySelector(selector);
    if (!element) return;
    element.classList.add(splideClass);
};
const addArrowsClassNames = (root)=>{
    addClassName(root, SPLIDE_ARROWS_ELEMENT_SELECTOR, SPLIDE_ARROWS_CLASS_NAME);
    root.querySelectorAll(SPLIDE_ARROW_ELEMENT_SELECTOR).forEach((element)=>{
        element.classList.add(SPLIDE_ARROW_CLASS_NAME);
        if (element.classList.contains(CUSTOM_ARROW_PREV)) {
            element.classList.add(SPLIDE_ARROW_PREV_CLASS_NAME);
        } else if (element.classList.contains(CUSTOM_ARROW_NEXT)) {
            element.classList.add(SPLIDE_ARROW_NEXT_CLASS_NAME);
        }
    });
};
export const addSplideClassNames = (root, needToAddArrows = false)=>{
    addClassName(root, SPLIDE_TRACK_ELEMENT_SELECTOR, SPLIDE_TRACK_CLASS_NAME);
    addClassName(root, SPLIDE_LIST_ELEMENT_SELECTOR, SPLIDE_LIST_CLASS_NAME);
    root.querySelectorAll(SPLIDE_SLIDE_CLASS_SELECTOR).forEach((element)=>{
        element.classList.add(SPLIDE_SLIDE_CLASS_NAME);
    });
    if (needToAddArrows) {
        addArrowsClassNames(root);
    }
};
export const getActiveClassName = (navElement)=>{
    const slides = navElement.querySelectorAll(SPLIDE_SLIDE_CLASS_SELECTOR);
    return Array.from(slides).flatMap((slide)=>Array.from(slide.classList)).find((cls)=>cls.includes(SPLIDE_ACTIVE_CLASS_NAME_CSS_MODULE));
};
export const syncSplideActiveTabClassNames = (navElement, activeClassName)=>{
    const slides = navElement.querySelectorAll(SPLIDE_SLIDE_CLASS_SELECTOR);
    if (!activeClassName) {
        return;
    }
    slides.forEach((slide)=>{
        slide.classList.toggle(activeClassName, slide.classList.contains(SPLIDE_ACTIVE_CLASS_NAME));
    });
};
